module.exports = __webpack_public_path__ + "img/pic_zwt.53da9d77.png";